import classNames from 'classnames';
import type { Ref } from 'react';
import styles from './StickyScrollbar.module.scss';

type Props = {
  hasOverflow: boolean;
  stickyScrollbarRef: Ref<HTMLDivElement>;
  stickyScrollbarContentRef: Ref<HTMLDivElement>;
  className?: string;
};

export const StickyScrollbar = ({
  hasOverflow,
  stickyScrollbarRef,
  stickyScrollbarContentRef,
  className,
}: Props) => {
  return (
    <div
      className={classNames(styles.stickyScrollbar, className, {
        [styles.stickyScrollbarHidden]: !hasOverflow,
      })}
      ref={stickyScrollbarRef}
    >
      <div className={styles.stickyScrollbarContent} ref={stickyScrollbarContentRef} />
    </div>
  );
};
